import { get, includes } from 'lodash/fp';

export function isRememberMeViolation(rejection) {
    const violations = get('data.violations', rejection);
    return includes('PASSWORD_NOT_CONFIRMED', violations);
}

export function isUnauthorized({ response }) {
    return get('status', response) === 401;
}
